import React, { FC } from "react";
import { NoteStyled } from "./FootNoteFromJson.styles";
import { FormComponentProps } from "../tools/typings";

const FootNoteFromJson: FC<FormComponentProps> = props => {
   return <NoteStyled>{props.formElementJson.label}</NoteStyled>;
};

export default FootNoteFromJson;
